import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
/* eslint-disable react/jsx-pascal-case */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  BackgroundArea,
  Icon,
  RowView,
} from "../../../../Component/style/common_style";
import { promises } from "dns";

export interface ModalOpen {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  onClose?: () => void;
}

const Tuto_Modal = (props: ModalOpen) => {
  const isOpen = props.visible;
  const setIsOpen = props.handleModal;
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const [step, setStep] = useState(1);

  const Close = () => {
    setIsOpen(false);
  };

  const handleClose = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }

    Close();
  };

  return (
    <BackgroundArea style={isOpen ? {} : { display: "none" }} translate="no">
      <ModalBox>
        <TitleBox>
          기능 안내
          <ExitBtn aria-label="기능 안내 닫기" onClick={handleClose} />
        </TitleBox>
        <Content_Box className="info">
          <Icon src={require("../../../../Image/Tuto/Tuto" + step + ".png")} />
          {step === 1 ? (
            <>
              <div className="subTitle">시크릿 초대 방송 주소 생성</div>
              <div>내가 원하는 팬들에게만 주소 전달!</div>
            </>
          ) : step === 2 ? (
            <>
              <div className="subTitle">실시간 채팅</div>
              <div>라이브 중 셀러와 대화해보세요~</div>
            </>
          ) : step === 3 ? (
            <>
              <div className="subTitle">고객 관리</div>
              <div>불편한 고객이 있다면 블랙리스트로 관리!</div>
            </>
          ) : step === 4 ? (
            <>
              <div className="subTitle">정산서 발송</div>
              <div>정산서와 알림톡으로 고객들에게 알려주세요!</div>
            </>
          ) : (
            <>
              <div className="subTitle">엑셀 상품등록</div>
              <div>엑셀로 한 번에 상품을 등록해보세요!</div>
            </>
          )}
        </Content_Box>

        <BtnArea>
          {step > 1 && (
            <div className="back" onClick={() => setStep(step - 1)}>
              이전
            </div>
          )}
          {step < 5 && <div onClick={() => setStep(step + 1)}>다음</div>}
        </BtnArea>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Tuto_Modal;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 20rem;
  margin: auto 0rem;
  background-color: var(--user-surface);
  color: var(--user-text);
  border-radius: 16px;
  overflow: hidden;
  padding: 30px 16px 16px;
  z-index: 99;
  color: var(--user-text);
  div.info {
    line-height: 25px;
  }
`;

const TitleBox = styled.div`
  box-sizing: border-box;
  min-height: 44px;
  padding-inline: 44px;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  display: flex;
  justify-content: center;
  position: relative;
`;

const ExitBtn = styled(ModalCloseButton)`  position: absolute;
  right: 0px;
`;

const Content_Box = styled.div`
  padding: 36px 0px 40px 0px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  flex-direction: column;
  display: flex;
  color: var(--user-text);
  .subTitle {
    font-family: var(--font-Pretendard-SemiBold);
    margin-top: 24px;
    font-size: 16px;
    color: var(--user-text);
  }
  div {
    font-size: 14px;
    color: var(--user-text-muted);
  }
`;

const BtnArea = styled(RowView)`
  gap: 8px;
  div {
    flex: 1;
    height: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    font-family: var(--font-Pretendard-Medium);
    color: white;
    background: linear-gradient(90deg, #7955f0, #3209b9);
    border-radius: 8px;
    cursor: pointer;
  }
  .back {
    background: var(--user-surface-raised);
    color: var(--user-text-muted);
  }
`;
